import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import CoreValues from '../components/CoreValues';
import Solutions from '../components/Solutions';
import Stats from '../components/Stats';
import Features from '../components/Features';
import Documentation from '../components/Documentation';
import IdVerification from '../components/IdVerification';
import Contact from '../components/Contact';

const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
      <CoreValues />
      <Solutions />
      <Stats />
      <Features />
      <Documentation />
      {/* <IdVerification /> */}
      <Contact />
    </>
  );
};

export default HomePage;